import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CashBankTransactionService} from 'app/shared/services/cash-bank-transaction.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';


@Component({
  selector: 'app-cash-bank-entry',
  templateUrl: './cash-bank-entry.component.html',
  styleUrls: ['./cash-bank-entry.component.css']
})
export class CashBankEntryComponent implements OnInit {

  cashBankDdata : any;
  cash_bankForm: FormGroup;
  bankAccountList : any[];
  showProcessingIndicator = false;
  isSaveBtnDisabled : boolean= false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  validationMessages = {
    'transNo': { 'required': 'Transaction Number  is required' },
    'transType': { 'required': 'Transaction Type is required' }, 
    'transDate': { 'required': 'Transaction Date is required' }, 
    'fromAccount': { 'required': 'From Account is required' }, 
    'toAccount': { 'required': 'To Account is required' }, 
    'amount': { 'required': 'Amount is required' }, 
  };

  formErrors = {
    'transNo': "",
    'transType': "",
    'transDate': "",
    'fromAccount': "",
    'toAccount': "",
    'amount': "",
  };

  TRANS_TYPE =[
    {value: 'Deposited'},
    {value: 'Withdrawn'},
    {value: 'Transfer'},
  ];

  constructor(private fb: FormBuilder,
              private cashBankTransactionService:CashBankTransactionService,
              private toastr: ToastrService,
              private authService: AuthService,
              private router : Router, 
              private bankAccountsService : BankAccountsService,
              public dialogRef: MatDialogRef<CashBankEntryComponent>
            ) { }

  ngOnInit(): void {


    this.cashBankDdata = {
      transNo: "",
      transType: "",
      transDate: "",
      fromAccount: "",
      toAccount: "",
      description: "",
      amount: "",
      createdBy : '',
    }

    this.initializeForm();
    this.getBankAccountList()
    this.isSaveBtnDisabled = false;

    this.getDataTableRowData();
    this.getControlPermissions();

  } //nd oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='CB'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {  
                  this.bankAccountList = data           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

  getMaxId(){
    var transNo = 0;
    var transNoPrefixZero  : String;
  
    this.cashBankTransactionService.getMaxId()
    .subscribe(
      (res) => {
           transNo  = Number(res[0].TransNo) + 1;
           transNoPrefixZero = transNo.toString().padStart(6,'0');       
          this.cash_bankForm.patchValue({
            transNo: "TRN" + transNoPrefixZero
          });
         
      },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )

   }

  initializeForm(){
    this.cash_bankForm = this.fb.group({
      transNo: ['', Validators.required],   
      transType:['', Validators.required],   
      transDate: ['', Validators.required],   
      fromAccount: ['', Validators.required],   
      toAccount: ['', Validators.required],   
      description : [''],  
      amount: ['', Validators.required],   
   
    });

  }



  newButtonClick(): void {
    this.cash_bankForm.reset();
    this.resetValiationErrors();
    this.getMaxId();
    
   }

   onClose(){
    this.cash_bankForm.reset();
    this.dialogRef.close();
   }
  saveButtonClick(): void {

    this.logValidationErrors(this.cash_bankForm, true);
    this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

        this.showProcessingIndicator = true;
        this.cashBankTransactionService.addCashBankEntry(this.cashBankDdata)
          .subscribe(
            (res) => {

              if(res.success === 0){
                this.cash_bankForm.patchValue({
                  transNo : res.autoId
                });
              this.saveButtonClick();
                this.showProcessingIndicator = false;
              }else if(res.success === 1){
                this.toastr.success('Record added successfully', 'Success');                                         
                this.isSaveBtnDisabled = true;
                this.showProcessingIndicator = false;
                this.onClose();
               
              }
                         
            },
            (err) => {
              this.toastr.error('Failed to add record', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )
      } else {  
        
          this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
          this.showProcessingIndicator = false;
    }


  }


  enableForm(): void {
    Object.keys(this.cash_bankForm.controls).forEach(key => {
      this.cash_bankForm.controls[key].enable();
    });
  }


  disableForm(): void {
    Object.keys(this.cash_bankForm.controls).forEach(key => {
      this.cash_bankForm.controls[key].disable();
    });
  }

  resetValiationErrors(){
    Object.keys(this.cash_bankForm.controls).forEach(key => {
      this.cash_bankForm.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.cash_bankForm, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.cash_bankForm.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    this.cashBankDdata.transNo= this.cash_bankForm.value.transNo;
    this.cashBankDdata.transType= this.cash_bankForm.value.transType;
    this.cashBankDdata.transDate= moment(this.cash_bankForm.value.transDate).format("YYYY-MM-DD"),
    this.cashBankDdata.fromAccount= this.cash_bankForm.value.fromAccount;
    this.cashBankDdata.toAccount= this.cash_bankForm.value.toAccount;
    this.cashBankDdata.description= this.cash_bankForm.value.description;
    this.cashBankDdata.amount= this.cash_bankForm.value.amount;
    this.cashBankDdata.createdBy = this.authService.getUserLoggedIn();

  }



  viewTransaction(data:any){

    this.cash_bankForm.patchValue({  
      transNo     :data.TransNo,
      transType   :data.TransType,
      transDate   :moment(data.TransDate).format("YYYY-MM-DD"),
      fromAccount : data.FromAccount,
      toAccount   : data.ToAccount,
      description : data.Description,
      amount      : data.Amount,
     
    })
  
  
  
  }
  
  getDataTableRowData(){
    var data = this.cashBankTransactionService.dataRow;
    if(data){
      this.viewTransaction(data);
      this.isSaveBtnDisabled= true;
    }
    else{
      this.newButtonClick();
    }
  
  }
  

   



}
